"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var async_1 = require("@shopify/async");

exports.DeferTiming = async_1.DeferTiming;

var Async_1 = require("./Async");

exports.Async = Async_1.Async;

var Prefetcher_1 = require("./Prefetcher");

exports.Prefetcher = Prefetcher_1.Prefetcher;

var PrefetchRoute_1 = require("./PrefetchRoute");

exports.PrefetchRoute = PrefetchRoute_1.PrefetchRoute;

var component_1 = require("./component");

exports.createAsyncComponent = component_1.createAsyncComponent;

var provider_1 = require("./provider");

exports.createAsyncContext = provider_1.createAsyncContext;

var utilities_1 = require("./utilities");

exports.resolve = utilities_1.resolve;
exports.trySynchronousResolve = utilities_1.trySynchronousResolve;

var hooks_1 = require("./hooks");

exports.useAsyncAsset = hooks_1.useAsyncAsset;

var assets_1 = require("./context/assets");

exports.AsyncAssetContext = assets_1.AsyncAssetContext;
exports.AsyncAssetManager = assets_1.AsyncAssetManager;

var prefetch_1 = require("./context/prefetch");

exports.PrefetchContext = prefetch_1.PrefetchContext;
exports.PrefetchManager = prefetch_1.PrefetchManager;